import { Layers } from "appworks/graphics/layers/layers";
import { AbstractControl } from "appworks/ui/controls/abstract-control";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { GamevyTotalStakeStepperControl } from "../controls/gamevy-total-stake-stepper-control";

export class GamevyTotalStakeStepperControlFactory implements ControlFactory {
    public filter(layer: Layers): boolean {
        return layer.getFlexiButton("gamevy_total_stake_stepper_down") != null &&
            layer.getFlexiButton("gamevy_total_stake_stepper_up") != null &&
            layer.getFlexiText("gamevy_total_stake_stepper_value") != null;
    }

    public build(layer: Layers): AbstractControl[] {
        return [
            new GamevyTotalStakeStepperControl(
                layer.getFlexiButton("gamevy_total_stake_stepper_down"),
                layer.getFlexiButton("gamevy_total_stake_stepper_up"),
                layer.getFlexiText("gamevy_total_stake_stepper_value")
            )
        ];
    }
}
